import { render, staticRenderFns } from "./IconGoogle.vue?vue&type=template&id=3089d1da"
import script from "./IconGoogle.vue?vue&type=script&lang=js"
export * from "./IconGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports